import { jsx as _jsx } from "react/jsx-runtime";
import { IconSize, InfoCircleIcon } from '../Icons';
import { Tooltip } from '../Tooltip';
export function Hint({ placement = 'top', color, size = IconSize.s, iconProps, className, ...restProps }) {
    return /*#__PURE__*/ _jsx(Tooltip, {
        placement: placement,
        ...restProps,
        children: /*#__PURE__*/ _jsx("span", {
            children: /*#__PURE__*/ _jsx(InfoCircleIcon, {
                type: "default",
                size: size,
                color: color,
                className: className,
                ...iconProps
            })
        })
    });
}
